import reducer from './state/reducer';
import { SEND_MFA_CODE, VERIFY_MFA_CODE } from './actions';

export default {
  name: 'mfa',
  reducer,
  asyncActions: [SEND_MFA_CODE, VERIFY_MFA_CODE],
};
